import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import "./NewInput.sass";

function NewInput({
  wrapperClass,
  className,
  type,
  id,
  label,
  error,
  complete,
  placeholder,
  value,
  onChange,
  onBlur,
  autofocus,
  onKeyPress,
}) {
  const classes = classNames(
    "input",
    error ? "error" : null,
    complete ? "complete" : null,
    className
  );

  return (
    <div className={classNames("inputWrapper", wrapperClass)}>
      {label && (
        <label className="inputLabel" htmlFor={id}>
          {label}
        </label>
      )}
      <input
        name={id}
        id={id}
        className={classes}
        type={type}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        autoFocus={autofocus}
        spellCheck="false"
        onKeyPress={onKeyPress}
      />
      {error && <span className="inputError">{error}</span>}
    </div>
  );
}

NewInput.defaultProps = {
  className: "",
  wrapperClass: "",
  type: "",
  id: "",
  label: "",
  error: "",
  complete: "",
  placeholder: "",
  value: "",
  autofocus: false,
  onChange: () => {},
  onBlur: () => {},
  onKeyPress: () => {},
};

NewInput.propTypes = {
  className: PropTypes.string,
  wrapperClass: PropTypes.string,
  type: PropTypes.string,
  id: PropTypes.string,
  label: PropTypes.string,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  complete: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  autofocus: PropTypes.bool,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  onKeyPress: PropTypes.func,
};

export default NewInput;
